import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { GlassCard } from './GlassCard';
import { ExternalLink } from 'lucide-react';
const newsSources = [{
  name: 'SecurityWeek',
  logo: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm5-img1.png'
}, {
  name: 'Cybernews',
  logo: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm5-img2.png'
}, {
  name: 'The Hacker News',
  logo: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm5-img3.png'
}, {
  name: 'Cyware',
  logo: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm5-img4.png'
}, {
  name: 'Bloomberg',
  logo: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm5-img5.png'
}, {
  name: 'Global News',
  logo: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm5-img6.png'
}];
const articles = [{
  category: 'Threat Intelligence',
  title: 'The Rise of AI-Driven Ransomware: What GRC Professionals Need to Know',
  date: 'March 15, 2026',
  excerpt: 'As attackers leverage large language models to automate exploit generation, traditional defense frameworks must evolve...',
  img: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm1_img_107068906.png'
}, {
  category: 'Industry Update',
  title: 'New Healthcare Compliance Standards: Navigating the 2026 HIPAA Revisions',
  date: 'March 12, 2026',
  excerpt: 'The latest updates to healthcare data privacy regulations introduce stricter requirements for third-party risk management...',
  img: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm6-img2.jpg'
}, {
  category: 'Academy News',
  title: 'CRS Expands Global Presence with New Training Hubs in West Africa',
  date: 'March 10, 2026',
  excerpt: 'Our mission to bridge the cybersecurity talent gap reaches new milestones with the launch of specialized GRC tracks...',
  img: 'https://www.cyberreadysecurity.info/wp-content/themes/cyberreadyip212/images/btm6-img1.jpg'
}];
export function IntelligenceHub() {
  return <section className="py-24 bg-background" data-id="element-221">
      <div className="container mx-auto px-6" data-id="element-222">
        <SectionHeading title="Cyber Intelligence Hub" subtitle="Stay ahead of the curve with the latest threat intelligence, industry updates, and academy news." data-id="element-223" />

        {/* Trusted Sources */}
        <div className="mb-20" data-id="element-224">
          <div className="text-center mb-8" data-id="element-225">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/30" data-id="element-226">
              Trusted Intelligence Partners
            </span>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-40 grayscale hover:grayscale-0 transition-all duration-700" data-id="element-227">
            {newsSources.map(source => <img key={source.name} src={source.logo} alt={source.name} className="h-6 md:h-8 w-auto object-contain" data-id="element-228" />)}
          </div>
        </div>

        {/* Articles Grid */}
        <div className="grid md:grid-cols-3 gap-8" data-id="element-229">
          {articles.map((article, i) => <motion.div key={article.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-230">
              <GlassCard className="group h-full flex flex-col border-white/5 hover:border-primary-blue/30 overflow-hidden" data-id="element-231">
                <div className="relative aspect-video overflow-hidden" data-id="element-232">
                  <img src={article.img} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-233" />
                  <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary-blue/90 backdrop-blur-md text-[10px] font-bold text-white uppercase tracking-wider" data-id="element-234">
                    {article.category}
                  </div>
                </div>
                <div className="p-8 flex flex-col flex-grow" data-id="element-235">
                  <div className="text-xs text-white/40 mb-3 font-medium" data-id="element-236">
                    {article.date}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4 group-hover:text-primary-blue transition-colors line-clamp-2" data-id="element-237">
                    {article.title}
                  </h3>
                  <p className="text-sm text-white/50 leading-relaxed mb-6 line-clamp-3" data-id="element-238">
                    {article.excerpt}
                  </p>
                  <div className="mt-auto pt-6 border-t border-white/5" data-id="element-239">
                    <button className="flex items-center gap-2 text-xs font-bold text-white group-hover:text-primary-blue transition-colors" data-id="element-240">
                      READ FULL ARTICLE <ExternalLink size={14} data-id="element-241" />
                    </button>
                  </div>
                </div>
              </GlassCard>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-242">
          <button className="px-8 py-4 rounded-full border border-white/10 text-white font-bold hover:bg-white/5 transition-all" data-id="element-243">
            View All Intelligence
          </button>
        </div>
      </div>
    </section>;
}